import { useState } from 'react'
import { CloseIcon } from 'assets/icons/CloseIcon'
import { Input } from 'components/Input/Input'
import { CheckBox } from 'components/CheckBox/CheckBox'
import { Modal } from 'components/Modal/Modal'
import useModalClose from 'hooks/useModalClose'
import { CursorPointer, Flex } from 'styling/GlobalStyles'
import { Button } from 'components/ui/Button/Button'
import { OtherText, TitleText } from 'styling/Typography'
import { IConfirmFoodKitchenRequest, IFoodStandbyConfigResponse } from 'types/api/foodApi.interface'

interface IProps {
  kitchenName: string
  windowName: string
  ordered: number
  standbyConfigs: IFoodStandbyConfigResponse[]
  closeModal: () => void
  onSubmit: (body: IConfirmFoodKitchenRequest) => void
}

export const KitchenConfirmationModal = ({
  kitchenName,
  windowName,
  ordered,
  standbyConfigs,
  closeModal,
  onSubmit,
}: IProps) => {
  const [served, setServed] = useState(String(ordered))
  const [standbyUsed, setStandbyUsed] = useState('0')
  const [onBehalf, setOnBehalf] = useState(false)
  const [onBehalfReason, setOnBehalfReason] = useState('')
  useModalClose(closeModal)

  const valid = served.trim() && Number(served) >= 0 && (!onBehalf || onBehalfReason.trim())

  const handleSubmit = () => {
    const qty = Number(standbyUsed || 0)
    const primary = standbyConfigs?.[0]
    const body: IConfirmFoodKitchenRequest = {
      servedCount: Number(served),
      standbyUsed:
        qty > 0
          ? [
              {
                dietaryTagCodes: (primary?.dietaryTags || []).map((t) => t.code),
                qty,
              },
            ]
          : [],
      enteredOnBehalf: onBehalf,
      onBehalfReason: onBehalf ? onBehalfReason.trim() : null,
    }
    onSubmit(body)
  }

  return (
    <Modal black width='520px'>
      <Flex column gap='1rem' width='100%'>
        <Flex between width='100%' center>
          <TitleText weight='bold'>
            Kitchen Confirmation — {kitchenName} · {windowName}
          </TitleText>
          <CursorPointer onClick={closeModal}>
            <CloseIcon />
          </CursorPointer>
        </Flex>
        <OtherText grey>Ordered (locked at cut-off): {ordered}</OtherText>
        <Flex gap='1rem' width='100%'>
          <Input
            type='number'
            labelText='Served count'
            placeholder='Enter served count'
            value={served}
            onChange={(e: any) => setServed(e.target.value)}
            nomarg
          />
          <Input
            type='number'
            labelText='Standby used'
            placeholder='Enter standby used'
            value={standbyUsed}
            onChange={(e: any) => setStandbyUsed(e.target.value)}
            nomarg
          />
        </Flex>
        <CheckBox
          square
          state={onBehalf}
          onClick={() => setOnBehalf(!onBehalf)}
          title='Entered on behalf of the kitchen (offline / contractor without access) — audited'
        />
        {onBehalf && (
          <Input
            type='textarea'
            labelText='On-behalf reason'
            value={onBehalfReason}
            onChange={(e: any) => setOnBehalfReason(e.target.value)}
            placeholder='e.g. Confirmed by phone'
            nomarg
          />
        )}
        <Flex gap='0.5rem' justcenter width='100%'>
          <Button variant='secondary' onClick={closeModal}>
            Cancel
          </Button>
          <Button variant='primary' disabled={!valid} onClick={handleSubmit}>
            Submit
          </Button>
        </Flex>
      </Flex>
    </Modal>
  )
}
